import { useQuery } from "@tanstack/react-query";
import { getMyMember } from "../api/membersApi";
import { queryKeys } from "../lib/queryKeys";

export function useMyMember(enabled = true) {
  return useQuery({
    queryKey: queryKeys.members.me,
    queryFn: () => getMyMember(),
    enabled,
  });
}
